// Shared video URL helpers used by explainer video slots and policy videos.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Resolve a stored/relative media URL into an absolute one.
export const resolveMediaUrl = (raw) => {
  if (!raw) return '';
  if (raw.startsWith('/api/')) return `${BACKEND_URL}${raw}`;
  return raw;
};

// Convert a raw video URL into an embeddable URL for YouTube/Vimeo/MP4.
export const toEmbedUrl = (raw) => {
  if (!raw) return null;
  const url = raw.trim();
  const ytMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{6,})/);
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
  const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  if (url.includes('/embed/') || url.includes('player.vimeo.com')) return url;
  return resolveMediaUrl(url);
};

// Whether a URL points to a direct video file (use <video> instead of <iframe>).
export const isDirectVideo = (raw) => {
  if (!raw) return false;
  return /\.(mp4|webm|mov|m4v)(\?|$)/i.test(raw) || raw.includes('/api/content/files/explainer_videos/');
};
